import { render } from "./ImageLabel.vue?vue&type=template&id=9cfb3dd2&scoped=true&ts=true"
import script from "./ImageLabel.vue?vue&type=script&lang=ts"
export * from "./ImageLabel.vue?vue&type=script&lang=ts"

import "./ImageLabel.vue?vue&type=style&index=0&id=9cfb3dd2&lang=less&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cfb3dd2"]])

export default __exports__